import React from "react";
import { SvgIcon } from "@mui/material";

export default function GooglePlayIcon() {
  return (
    <SvgIcon width="26" height="26" viewBox="0 0 26 26" fill="none">
      <g clipPath="url(#clip0_6703_57100)">
        <path
          d="M18.5879 16.9016C21.847 15.2755 24.3175 14.0365 24.5305 13.9402C25.2117 13.611 25.9152 12.7397 24.5305 12.063C24.0834 11.8501 21.6763 10.6497 18.5879 9.10156L14.3066 13.0305L18.5879 16.9015V16.9016Z"
          fill="#FFD900"
        />
        <path
          d="M15.5376 13L1.91016 25.9901C2.23002 26.0301 2.59114 25.9499 3.0169 25.7286C3.91076 25.2658 13.3866 20.3715 19.8174 17.0288L15.5376 13Z"
          fill="#F43249"
        />
        <path
          d="M15.5427 13L19.8174 8.91708C19.8174 8.91708 3.99411 0.709803 3.03674 0.225318C2.67605 0.0222824 2.27185 -0.0380281 1.91016 0.0222824L15.5427 13Z"
          fill="#00EE76"
        />
        <path
          d="M15.6816 12.9599L1.58488 0C1.01277 0.121406 0.529297 0.585339 0.529297 1.53414V24.4458C0.529297 25.3142 0.903412 25.9397 1.60676 26L15.6816 12.9599Z"
          fill="#00D3FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6703_57100">
          <rect
            width="24.7947"
            height="26"
            fill="white"
            transform="translate(0.529297)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
